import { Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../../PDFProvider';
import { styles } from '../styles';

export function SalesRep() {
  const { customer } = usePDFContext();

  const { salesRepId, salesRepName, salesRepEmail, salesRepPhone } = customer;

  if (!salesRepId) {
    return null;
  }

  if (salesRepName) {
    return (
      <View style={[styles.column, styles.widthFull]}>
        <View style={[styles.row, styles.justifyBetween]}>
          <Text>Sales Rep</Text>
          <Text>{salesRepName}</Text>
        </View>
        <View style={[styles.column, styles.alignEnd]}>
          {salesRepEmail ? <Text>{salesRepEmail}</Text> : null}
          {salesRepPhone ? <Text>{salesRepPhone}</Text> : null}
        </View>
      </View>
    );
  }

  return (
    <>
      <Text>Sales Rep</Text>
      <Text>{salesRepName}</Text>
    </>
  );
}
